module.exports = __webpack_public_path__ + "static/pacte_transition-202a86db9833249497e6b594cc60a2c4.png";